module.exports = __webpack_public_path__ + "static/media/portfolio1.18a980a7.jpg";